// removed by extract-text-webpack-plugin
module.exports = {"yx_yxCircle_sm":"yx_yxCircle_sm___33CEG","yx_yxShadow_right":"yx_yxShadow_right___awAwl","yx_yxShadow_left":"yx_yxShadow_left___20vOu","yx_yxShadow_down":"yx_yxShadow_down___2mRhc","yx_yxShadow_down_new":"yx_yxShadow_down_new___3D21b","yx_yxRadius_sm":"yx_yxRadius_sm___3fYiI","yx_yxRadius_xs":"yx_yxRadius_xs___2CDln","yx_yxLine":"yx_yxLine___3vc4I","ant-layout-content":"ant-layout-content___wgqzP"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/FooterBar/FooterBarLess.less
// module id = ./src/widget/FooterBar/FooterBarLess.less
// module chunks = 43